import React, { useState, useEffect } from "react";
import ManualMeditionModal from "./manual-medition-modal";
import ReactDOMServer from "react-dom/server";
import Swal from "sweetalert2";
import { FaCube, FaRegSquare, FaWindows, FaTimes } from "react-icons/fa";
import "./entries.css";
import PalletSelectionModal from "./pallet-selection-modal";
import axios from "axios";

function CubiscanForm({ master, subproduct, isConsolidated }) {
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupTwo, setShowPopupTwo] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [masterData, setMasterData] = useState(null);
  const [houses, setHouses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cubiscan, setCubiscan] = useState({});
  const [selectedAuditorId, setSelectedAuditorId] = useState(null);
  const [tolerance, setTolerance] = useState(null);
  const [hasEvaluatedTolerance, setHasEvaluatedTolerance] = useState(false);
  const [isExcluded, setIsExcluded] = useState(false);

  useEffect(() => {
    const masterInfoFromParent = master?.resp || master;
    const masterId =
      masterInfoFromParent?.id || masterInfoFromParent?.master_id;
    if (!masterId) return;

    setTolerance(null);
    setHasEvaluatedTolerance(false);
    setIsExcluded(false);

    if (isConsolidated) {
      fetchParcialities(masterId);
    } else {
      fetchForm(masterId);
    }
  }, [master, isConsolidated]);

  const fetchParcialities = async (masterId) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/cubiscan/parcialities`,
        {
          params: {
            master_id: masterId,
            house_id: masterId,
          },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      setHouses(res.data?.data?.data || []);
    } catch (error) {
      console.error("Error parcialities:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCubiscanData = async (masterId, isConsolidatedFlag = null) => {
    setLoading(true);

    try {
      let url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/cubiscan`;
      let params = { master_id: masterId };

      let res;

      // 🟦 CASE 1 → CONSOLIDADO
      if (isConsolidatedFlag) {
        url += "/parcialities";
        params.house_id = masterId;

        res = await axios.get(url, {
          params,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        });

        const cubi = res.data?.data;

        setMasterData(cubi?.resp || {});
        setHouses(cubi?.data || []);
        setCubiscan(cubi?.cubiscan || {});

        return;
      }

      // 🟧 CASE 2 → NO CONSOLIDADO (usa /form)
      url += "/form";

      res = await axios.get(url, {
        params,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      const cubi = res.data?.data;

      // Datos del master (del objeto master)
      const masterInfo = {
        awb: cubi.awb,
        master_id: cubi.master.id,
        id: cubi.master.id,
        master_orig: cubi.master.origin,
        master_dest: cubi.master.destiny,
        master_pieces: cubi.master.pieces,
        master_weight: cubi.master.weight,
        master_volume: cubi.master.volume,
        master_merch: cubi.master.description,
        master_chargeable_weight: cubi.master.chargeable_weight,
      };

      // Data[] SOLO tiene información del archivo
      setHouses(cubi.data || []);

      // cubiscan contiene las mediciones reales
      setCubiscan(cubi.cubiscan || {});

      setMasterData(masterInfo);
    } catch (error) {
      console.error("❌ Error en fetchCubiscanData:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = () => {
    alert("Actualizar");
  };

  const handleSave = () => {
    const hasSelection = houses.some((h) => h.checkedGross || h.checkedReal);

    if (!hasSelection) return;

    // 🔥 AQUÍ se evalúa por primera vez
    setHasEvaluatedTolerance(true);

    // Si cumple, se habilitan botones
    if (tolerance === 0) {
      setShowButtons(true);
    }
  };

  // const handleSave = () => {
  //   const hasSelection = houses.some((h) => h.checkedGross || h.checkedReal);

  //   if (!hasSelection) {
  //     return;
  //   }

  //   // setShowAlert(false); // ocultar mensaje si si hay algun checkbox seleccionado
  //   setShowButtons(true);
  // };

  const handleCheck = (index, type) => {
    setHouses((prev) =>
      prev.map((row, i) => {
        if (i !== index) return row; // ⛔ NO afecta otras filas

        return {
          ...row,
          checkedGross: type === "gross" ? true : false,
          checkedReal: type === "real" ? true : false,
        };
      })
    );

    setShowAlert(false); // si ya eligió algo, ocultamos alert
  };

  const handleExcludelMedition = () => {
    const masterId = masterData?.master_id || masterData?.id;

    if (!masterId) {
      Swal.fire("Error", "No se encontró Master ID.", "error");
      return;
    }

    // Primer mensaje
    const firstHtml = ReactDOMServer.renderToString(
      <div className="container-fluid">
        <p>¿Seguro que desea excluir la medición del Cubiscan?</p>
      </div>
    );

    Swal.fire({
      title: "",
      html: firstHtml,
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      icon: "warning",
      customClass: {
        confirmButton: "btn-okk",
        cancelButton: "btn-canceel",
        popup: "alert-bg",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Segundo mensaje
        const secondHtml = ReactDOMServer.renderToString(
          <div className="container-fluid">
            <p className="fw-bold">¿Seguro que quieres aceptar la guía?</p>
            <small style={{ color: "#DC3545", fontWeight: "700" }}>
              Esta acción es irreversible.
            </small>
          </div>
        );

        Swal.fire({
          title: "",
          html: secondHtml,
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          icon: "warning",
          customClass: {
            confirmButton: "btn-okk",
            cancelButton: "btn-canceel",
            popup: "alert-bg",
          },
        }).then(async (finalResult) => {
          if (finalResult.isConfirmed) {
            try {
              const url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/cubiscan/excludeMedition`;

              const payload = {
                master_id: masterId,
                house_id: null,
              };

              const res = await axios.post(url, payload, {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                  "Content-Type": "application/json",
                },
              });

              Swal.fire({
                icon: "success",
                title: "Éxito",
                text: "La medición del cubiscan fue excluida.",
              });

              setIsExcluded(true);
              setHasEvaluatedTolerance(true);
              setTolerance(0);

              const masterIdReload = masterData?.master_id || masterData?.id;
              fetchForm(masterIdReload);
            } catch (error) {
              console.error("Error al excluir medición:", error);

              Swal.fire({
                icon: "error",
                title: "Error",
                text:
                  error.response?.data?.message ||
                  "Ocurrió un error al excluir la medición.",
              });
            }
          }
        });
      }
    });
  };

  const handleDeleteFile = (fileId, fileName) => {
    const htmlConfirm = ReactDOMServer.renderToString(
      <div className="container-fluid">
        <p>¿Seguro que deseas eliminar este archivo del Cubiscan?</p>
        <p className="fw-bold">{fileName}</p>
        <small style={{ color: "#DC3545", fontWeight: "700" }}>
          Esta acción es irreversible.
        </small>
      </div>
    );

    Swal.fire({
      title: "",
      html: htmlConfirm,
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
      icon: "warning",
      customClass: {
        confirmButton: "btn-okk",
        cancelButton: "btn-canceel",
        popup: "alert-bg",
      },
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        const url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/cubiscan/deleteFile`;

        const payload = {
          id: fileId,
          name: fileName,
        };

        const res = await axios.post(url, payload, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        Swal.fire({
          icon: "success",
          title: "Archivo eliminado",
          text: "El archivo fue eliminado correctamente.",
        });

        window.location.reload();
      } catch (error) {
        console.error("❌ Error al eliminar archivo:", error);

        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error.response?.data?.message || "No se pudo eliminar el archivo.",
        });
      }
    });
  };

  const handleGetTicket = async () => {
    try {
      const masterId = masterData?.master_id || masterData?.id;

      if (!masterId) {
        return Swal.fire("Error", "No se encontró Master ID.", "error");
      }

      const url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/cubiscan/getTicket?id=${masterId}`;

      if (tolerance === null) {
        return Swal.fire(
          "Atención",
          "La medición aún no ha sido evaluada.",
          "warning"
        );
      }

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      Swal.fire({
        icon: "success",
        title: "Ticket generado",
        text: "El ticket se generó correctamente.",
      });
    } catch (error) {
      console.error("❌ Error al generar ticket:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "No se pudo generar el ticket.",
      });
    }
  };

  const handleSavePallets = async (payload) => {
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/cubiscan/savePallets`;

      const res = await axios.post(url, payload, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Pallets guardados",
        text: "Los pallets se guardaron correctamente.",
      });

      window.location.reload();
    } catch (error) {
      console.error("❌ Error savePallets:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          "No se pudieron guardar los pallets.",
      });
    }
  };

  const handleAcceptGuide = async () => {
    const selected = houses.filter((h) => h.checkedGross || h.checkedReal);

    if (selected.length === 0) {
      return Swal.fire(
        "Error",
        "Debe seleccionar una medición válida",
        "error"
      );
    }

    try {
      const masterId = masterData?.master_id || masterData?.id;

      const payload = {
        master_id: masterId,
        house_id: null,
        medType: selected.map((h) => (h.checkedGross ? 1 : 2)),
        id: selected.map((h) => h.id_exp_auditor || h.id),
        client_autorization: true,
      };

      const url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/cubiscan/save`;

      const res = await axios.post(url, payload, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Guía aceptada",
        text: "La guía ha sido aceptada correctamente.",
      });

      window.location.reload();
    } catch (error) {
      console.error("❌ Error al aceptar guía:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "No se pudo aceptar la guía.",
      });
    }
  };

  const fetchForm = async (masterId) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/cubiscan/form`,
        {
          params: { master_id: masterId },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      const cubi = res.data?.data;
      
      setTolerance(cubi.tolerance ?? null);
      setHasEvaluatedTolerance(cubi.tolerance !== null && cubi.tolerance !== undefined);

      setMasterData({
        awb: cubi.awb,
        master_orig: cubi.master.origin,
        master_dest: cubi.master.destiny,
        master_merch: cubi.master.description,
        master_pieces: cubi.master.pieces,
        master_weight: cubi.master.weight,
        master_volume: cubi.master.volume,
        id: cubi.master.id,
      });

      setHouses(
        (cubi.data || []).map((h) => ({
          ...h,
          checkedGross: false,
          checkedReal: false,
          hasPallets: h.has_pallets !== false,
          isManual: h.medition_type === null,
        }))
      );

      // setHouses(
      //   (cubi.data || []).map((h) => ({
      //     ...h,
      //     checkedGross: h.medition_type === 1,
      //     checkedReal: h.medition_type === 2,
      //     hasPallets: h.has_pallets !== false,
      //   }))
      // );

      const rows = cubi.data?.length || 0;

      const realVolumeArr = splitCubeVol(cubi.cubiscan?.cubevol_gross, rows);

      const GROSS_FACTOR = 1.863;

      const grossVolumeArr = realVolumeArr.map((v) =>
        Number((v * GROSS_FACTOR).toFixed(2))
      );

      const parsedCubiscan = {
        grossWeightArr: splitByRows(cubi.cubiscan?.weight_gross, rows),
        realWeightArr: splitByRows(cubi.cubiscan?.weight_net, rows),

        realVolumeArr,
        grossVolumeArr,
      };

      // const parsedCubiscan = {
      //   weightGrossArr: splitCubiscanValues(cubi.cubiscan?.weight_gross),
      //   weightNetArr: splitCubiscanValues(cubi.cubiscan?.weight_net),

      //   cubevolGrossArr: splitCubiscanValues(cubi.cubiscan?.cubevol_gross),

      //   realVolArr: cubi.cubiscan?.vol_kgb
      //     ? splitCubiscanValues(cubi.cubiscan.vol_kgb)
      //     : splitCubiscanValues(cubi.cubiscan?.cubevol_gross),
      // };

      setCubiscan(parsedCubiscan);
    } catch (error) {
      console.error("Error form:", error);
    } finally {
      setLoading(false);
    }
  };

  const splitByRows = (str, rows) => {
    if (!str || !rows) return [];

    const clean = str.replace(/\s+/g, "");
    const size = Math.floor(clean.length / rows);

    const result = [];
    let cursor = 0;

    for (let i = 0; i < rows; i++) {
      // Última fila se queda con el resto
      const part =
        i === rows - 1
          ? clean.substring(cursor)
          : clean.substring(cursor, cursor + size);

      result.push(Number(part));
      cursor += size;
    }

    return result;
  };

  const splitCubeVol = (str, rows) => {
    if (!str || !rows) return [];

    const clean = str.replace(/\s+/g, "");
    const CHUNK_SIZE = 8; // #####.##

    const result = [];

    for (let i = 0; i < rows; i++) {
      const start = i * CHUNK_SIZE;
      const part = clean.substring(start, start + CHUNK_SIZE);
      result.push(Number(part));
    }

    return result;
  };

  const isToleranceEvaluated = hasEvaluatedTolerance === true;

  const showSuccessAlert =
    !isConsolidated && isToleranceEvaluated && (isExcluded || tolerance === 0);

  const showErrorAlert =
    !isConsolidated &&
    !isExcluded &&
    isToleranceEvaluated &&
    (tolerance === 1 || tolerance === -1);

  return (
    <>
      <div className="container-fluid">
        {!isConsolidated && (
          <>
            <div className="row">
              <div className="col-3">
                <p>
                  <span className="fw-bold">Master:</span> {masterData?.awb}
                </p>
              </div>
              <div className="col-3">
                <p>
                  <span className="fw-bold">Origen:</span>{" "}
                  {masterData?.master_orig}
                </p>
              </div>
              <div className="col-3">
                <p>
                  <span className="fw-bold">Destino:</span>{" "}
                  {masterData?.master_dest}{" "}
                </p>
              </div>
              <div className="col-3">
                <p>
                  <span className="fw-bold">Tipo de mercancía:</span>{" "}
                  {masterData?.master_merch}{" "}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-3">
                <p>
                  <span className="fw-bold">Piezas Master:</span>{" "}
                  {masterData?.master_pieces}{" "}
                </p>
              </div>
              <div className="col-3">
                <p>
                  <span className="fw-bold">Peso Master:</span>{" "}
                  {masterData?.master_weight}{" "}
                </p>
              </div>
              <div className="col-3">
                <p>
                  <span className="fw-bold">Volúmen Master:</span>{" "}
                  {masterData?.master_volume}{" "}
                </p>
              </div>
              {subproduct &&
                {
                  /* <div className="col-3">
              <p>
                <span className="fw-bold">HBS:</span> {subproduct.hbs}{" "}
              </p>
            </div> */
                }}
              {subproduct &&
                {
                  /* <div className="row">
            <div className="col-3">
              <p>
                <span className="fw-bold">Piezas House:</span>{" "}
                {subproduct.pieces}{" "}
              </p>
            </div>
            <div className="col-3">
              <p>
                <span className="fw-bold">Peso House:</span> {subproduct.weight}{" "}
              </p>
            </div>
            <div className="col-3">
              <p>
                <span className="fw-bold">Volúmen House:</span>{" "}
                {subproduct.volume}{" "}
              </p>
            </div>
          </div> */
                }}
            </div>
          </>
        )}

        <div className="row">
          {/* 1. Visibilidad de botones (Excluir medición y Medición manual) */}
          {!isConsolidated && ( // SOLO visible si NO es consolidada (Master Pura)
            <>
              {!isExcluded &&
                !isConsolidated &&
                (tolerance === null || tolerance === 1 || tolerance === -1) && (
                  <div className="col-6">
                    <button
                      className="btn btn-danger"
                      onClick={handleExcludelMedition}
                    >
                      Excluir medición cubiscan
                    </button>
                  </div>
                )}

              <div className="col-6 text-end">
                {!isExcluded && (
                  <button className="btnn" onClick={() => setShowPopup(true)}>
                    Medición manual
                  </button>
                )}
                {!isConsolidated && tolerance === 1 && (
                  <button className="btnn me-2" onClick={handleAcceptGuide}>
                    Aceptar guía
                  </button>
                )}
              </div>
            </>
          )}
          {isConsolidated && ( // Si es consolidada, puedes dejar un espacio o algo que indique que no hay botones de medición aquí
            <div className="col-12" style={{ height: "40px" }}>
              {/* Espacio para la Guía Consolidada. Los botones de acción se gestionan en FormsView. */}
            </div>
          )}
        </div>

        {/* 2. Renderizado Condicional de la Tabla */}
        {isConsolidated ? (
          // ** NO HACEMOS NADA AQUÍ **: Si es consolidada, la lista de Houses se muestra en FormsView para la selección.
          <></>
        ) : (
          // ** Si es Master Pura: Mostrar la tabla de MEDICIONES (desde /form) **
          <table className="table table-striped mt-3">
            <thead className="text-center">
              <tr>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Nombre archivo
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Gross Weight <FaCube />{" "}
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Gross Volume <FaCube />{" "}
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Real Weight <FaRegSquare />{" "}
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Real Volume <FaRegSquare />{" "}
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody className="text-center">
              {houses.length === 0 ? (
                <tr>
                  <td colSpan="6">No hay mediciones registradas</td>
                </tr>
              ) : (
                houses.map((h, index) => {
                  const canOpenPallets =
                    !isExcluded &&
                    h.checkedReal &&
                    !h.checkedGross &&
                    (h.hasPallets || h.isManual || h.medition_type === null);

                  const canDelete =
                    !isExcluded && !h.checkedGross && !h.checkedReal;

                  return (
                    <tr key={h.id_exp_auditor || index}>
                      <td>{h.file_name || `Archivo ${index + 1}`}</td>
                      <td>
                        {h.gross_weight ??
                          cubiscan.grossWeightArr?.[index] ??
                          "--"}
                      </td>
                      <td>
                        {h.gross_volume != null
                          ? `${(h.gross_volume / 1000).toFixed(5)} m3`
                          : cubiscan.grossVolumeArr?.[index] != null
                          ? `${(cubiscan.grossVolumeArr[index] / 1000).toFixed(
                              5
                            )} m3`
                          : "--"}
                      </td>
                      <td>
                        {h.real_weight ??
                          cubiscan.realWeightArr?.[index] ??
                          "--"}
                      </td>
                      <td>
                        {h.real_volume != null
                          ? `${(h.real_volume / 1000).toFixed(5)} m3`
                          : cubiscan.realVolumeArr?.[index] != null
                          ? `${(cubiscan.realVolumeArr[index] / 1000).toFixed(
                              5
                            )} m3`
                          : "--"}
                      </td>
                      <td>
                        {/* ... Lógica de Checkboxes y botones para Master Pura/Mediciones ... */}
                        <FaCube
                          size={20}
                          style={{ marginRight: "5px", color: "#020C41" }}
                        />
                        <input
                          className="form-check-input"
                          type="checkbox"
                          // name="check1"
                          checked={h.checkedGross}
                          disabled={isExcluded}
                          onChange={() => handleCheck(index, "gross")}
                          style={{ marginRight: "20px" }}
                        />
                        {/* ... (resto de botones y checks) ... */}
                        <FaRegSquare
                          size={20}
                          style={{ marginRight: "5px", color: "#020C41" }}
                        />
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="check2"
                          checked={h.checkedReal}
                          disabled={isExcluded}
                          onChange={() => handleCheck(index, "real")}
                          style={{ marginRight: "15px" }}
                        />
                        <button
                          style={{ border: "none" }}
                          onClick={() => {
                            setSelectedAuditorId(h.id_exp_auditor);
                            setShowPopupTwo(true);
                          }}
                          // onClick={() => setShowPopupTwo(true)}
                          // disabled={!h.checkedReal || !h.hasPallets}
                          disabled={!canOpenPallets}
                        >
                          <FaWindows
                            size={20}
                            style={{
                              transform: "rotate(90deg)",
                              opacity: canOpenPallets ? 1 : 0.4,
                              cursor: canOpenPallets
                                ? "pointer"
                                : "not-allowed",
                            }}
                          />
                        </button>
                        <button
                          onClick={() =>
                            handleDeleteFile(
                              h.id_exp_auditor || h.id,
                              h.file_name
                            )
                          }
                          disabled={!canDelete}
                          style={{
                            background: "none",
                            border: "none",
                            cursor: canDelete ? "pointer" : "not-allowed",
                            opacity: canDelete ? 1 : 0.4,
                          }}
                        >
                          <FaTimes size={20} style={{ color: "#020C41" }} />
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        )}

        {showSuccessAlert && (
          <div className="alert alert-success mt-3 text-center" role="alert">
            <p>Cumplió con el rango:</p>
            <p>Valores aceptados, se cobra conforme los datos de la guía.</p>
          </div>
        )}

        {showErrorAlert && (
          <div className="alert alert-danger mt-3 text-center" role="alert">
            <p className="fw-bold">No cumplió con el rango:</p>
            <p>
              Los valores exceden el rango permitido, favor de validar el
              proceso correspondiente.
            </p>
          </div>
        )}

        {showAlert && (
          <div className="alert alert-danger" role="alert">
            Se deben seleccionar todos los tipos de medición o eliminar las
            mediciones que no se utilizarán.
          </div>
        )}

        {!isConsolidated && (
          <div className="row">
            <div className="col mt-4 d-flex justify-content-end gap-3">
              <button className="btnn" onClick={handleUpdate}>
                Actualizar
              </button>
              <button
                className="btnn"
                onClick={handleSave}
                disabled={hasEvaluatedTolerance && tolerance !== 0}
              >
                Guardar
              </button>

              {/* Ticket SIEMPRE visible para master pura */}
              <button className="btnn" onClick={handleGetTicket}>
                Ticket
              </button>
            </div>
          </div>
        )}

        {/* {!isConsolidated && (
          <div className="row">
            <div className="col mt-4 d-flex justify-content-end gap-3">
              <button className="btnn" onClick={handleUpdate}>
                Actualizar
              </button>
              <button className="btnn" onClick={handleSave}>
                Guardar
              </button>
              {activeCheckbox === "check1" && showButtons && (
                <button
                  className="btnn"
                  onClick={() => alert("Generar ticket")}
                >
                  Ticket
                </button>
              )}
            </div>
          </div>
        )} */}

        {/* <div class="alert alert-success" role="alert">
                    Cumplio con el rango: <br />
                    Valores aceptados por el tipo de mercancía (remesa), se cobrara conforme los datos de la guia.                    
                </div> */}
      </div>
      {showPopup && (
        <ManualMeditionModal
          master={master}
          onClose={() => setShowPopup(false)}
          // fetchCubiscanData={(id) => fetchCubiscanData(id, isConsolidated)}
          onManualAdded={(row) => {
            setHouses((prev) => [
              ...prev,
              {
                ...row,
                checkedGross: false,
                checkedReal: false,
                hasPallets: true, // o lo que aplique
                isManual: true, // 👈 CLAVE
              },
            ]);
            //setManualAdded(true);
          }}
        />
      )}
      {showPopupTwo && (
        <PalletSelectionModal
          // master={masterData}
          cubiscan={cubiscan}
          // selectedType={selectedType}
          onClose={() => setShowPopupTwo(false)}
          idExpAuditor={selectedAuditorId}
          // onSubmit={(payload) => handleSavePallets(payload)}
        />
      )}
    </>
  );
}

export default CubiscanForm;